import ChatHistory from './ChatHistory';
import Hero from './Hero';
import PopularTopics from './PopularTopics';
import PrivacyPolicy from './PrivacyPolicy';

import { HomeBodyContent } from './styles';
import { htmlId } from 'utils/html';

const Home = () => {
  return (
    <>
      <Hero id={htmlId('home-hero')} />
      <HomeBodyContent id={htmlId('home-body-content')}>
        <PopularTopics id={htmlId('home-popular-topics')} />
        <ChatHistory id={htmlId('home-chat-history')} />
        <PrivacyPolicy id={htmlId('home-privacy-policy')} />
      </HomeBodyContent>
    </>
  );
};

export default Home;
